import { CloseIcon } from '@/components/common/icon';
import WebModal from '@/components/web/components/Modal';
import { isMobile } from '@/biz/tool';
import { useWebModalStore } from '@/hooks/useWebModalStore';
const ModalShowImage = () => {
  const { showModalShowImage, modalImageUrl, setShowModalShowImage } =
    useWebModalStore();

  const AudienceInsightsImage = ({ onClose }: { onClose: () => void }) => {
    return (
      <div className="relative" onClick={onClose}>
        <div className="absolute top-[0px] right-[-70px] rounded-full p-2 cursor-pointer bg-gray-200">
          <CloseIcon className="w-6 h-6" onClick={onClose} />
        </div>
        <img
          alt="audience-insights"
          src={modalImageUrl}
          className=""
          style={{
            maxWidth: '90vw',
            maxHeight: '90vh',
            objectFit: 'contain',
            width: 'auto',
            height: 'auto',
            margin: '0 auto'
          }}
        />
      </div>
    );
  };

  return (
    <WebModal
      visible={showModalShowImage}
      canClose={true}
      handleClose={() => setShowModalShowImage(false)}
      isShowFooter={false}
      isShowHeader={false}
      width={isMobile() ? 375 : undefined}
      modalStyle={{ zIndex: 2000 }}
      style={{
        width: isMobile() ? '375px' : '1000px',
        height: 'auto',
        maxWidth: '90%',
        maxHeight: '90%',
        background: 'transparent'
      }}
      className={`!z-[99999999]
        ${isMobile() ? 'p-0' : 'p-0'}
        `}
    >
      <AudienceInsightsImage onClose={() => setShowModalShowImage(false)} />
    </WebModal>
  );
};

export default ModalShowImage;
